import { Modal, Button } from "@hiya/ui";

interface UnassignDoctorModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function UnassignDoctorModal({ open, onClose, onConfirm }: Readonly<UnassignDoctorModalProps>) {
  return (
    <Modal open={open} title="Unassign doctor" onClose={onClose}>
      <p className="text-base text-text-secondary">
        Are you sure you want to unassign doctor?
      </p>
      <div className="flex gap-3 mt-2">
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Unassign doctor
        </Button>
      </div>
    </Modal>
  );
}
